import React, { useState } from "react";
import "./Near_You.css";
import Show_Programs_Modal from "../../common/modals/show_programs_modal/Show_Programs_Modal";
import { useLocation } from "react-router-dom";

const Near_You = () => {
  const [showModal, setShowModal] = useState(false);
  // full form data

  return (
    <section className="Near_You">
      <div className="container">
        <div className="main_div">
          <div className="left_img_div">
            <img
              src="/assets/images/event_registration/near_you/left.png"
              className="left_img"
            />
          </div>

          <div className="white_card">
            <p className="title_text">Near You</p>

            <div className="map_holder">
              <img
                src="/assets/images/event_registration/near_you/map.png"
                className="map_img"
              />
            </div>

            <p className="see_text">See What’s Happening Around You!</p>
            <p className="light_gray_text">
              To explore nearby events, services, & experiences, please enable
              your location
            </p>

            <button className="enable_btn">Enable Location Permission</button>

            <div
              className="see_all_div"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <span className="see_text">See All</span>
            </div>
          </div>

          <div className="right_img_div">
            <img
              src="/assets/images/event_registration/near_you/right.png"
              className="right_img"
            />
          </div>
        </div>
      </div>

      <Show_Programs_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Near_You;
